import { getRequest, postRequest, deleteRequest } from "./ApiInstence";

// Create Razorpay order
export const createOrderApi = (data) =>
  postRequest("create-order/", data);

// Verify Razorpay payment
export const verifyPaymentApi = (data) =>
  postRequest("verify-payment/", data);

// Current plan details
export const currentPlanApi = () =>
  getRequest("current-plan/");

// Billing history
export const billingHistoryApi = () =>
  getRequest("billing-history/");

// Download invoice
export const downloadInvoiceApi = (invoice_id) =>
  getRequest(`download-invoice/${invoice_id}/`);

// User settings (notifications, security preferences)
// export const getUserSettingsApi = () =>
//   getRequest("user-settings/");

// export const updateUserSettingsApi = (data) =>
//   postRequest("user-settings/", data);

// Credit balance
export const getCreditBalanceApi = () =>
  getRequest("credit-balance/");

// User profile
export const getProfileApi = () =>
  getRequest("profile/");

export const updateProfileApi = (data) =>
  postRequest("account/create-profile/", data);

// =====================================================================
// DEVICE MANAGEMENT
// =====================================================================
export const listDevicesApi = () =>
  getRequest("devices/");

export const removeDeviceApi = (device_id) =>
  deleteRequest(`devices/${device_id}/remove/`);

export const setCurrentDeviceApi = (device_id) =>
  postRequest(`devices/${device_id}/set-current/`, {});

export const logoutDeviceApi = (device_id) =>
  postRequest(`devices/${device_id}/logout/`, {});

// =====================================================================
// LOGIN HISTORY
// =====================================================================
export const getLoginHistoryApi = (page = 1, page_size = 20) =>
  getRequest(`login-history/?page=${page}&page_size=${page_size}`);

export const deleteLoginHistoryApi = (history_id) =>
  deleteRequest(`login-history/delete/${history_id}/`);

// =====================================================================
// TWO-FACTOR AUTHENTICATION (2FA)
// =====================================================================
export const send2FAEnableCodeApi = () =>
  postRequest("2fa/send-enable/", {});

export const verify2FAEnableCodeApi = (code) =>
  postRequest("2fa/verify-enable/", { code });

export const send2FALoginCodeApi = () =>
  postRequest("2fa/send-login/", {});

export const verify2FALoginCodeApi = (code) =>
  postRequest("2fa/verify-login/", { code });

export const disable2FAApi = () =>
  postRequest("2fa/disable/", {});

export const get2FAStatusApi = () =>
  getRequest("2fa/status/");

export const resend2FACodeApi = () =>
  postRequest("2fa/resend-code/", {});

// =====================================================================
// PASSWORD MANAGEMENT
// =====================================================================
export const changePasswordApi = (data) =>
  postRequest("password/change/", data);

// Password reset flow
export const requestPasswordResetApi = (data) =>
  postRequest("password-reset/request/", data);

export const verifyPasswordResetOtpApi = (data) =>
  postRequest("password-reset/verify/", data);

// =====================================================================
// SEO TRIAL & ELIGIBILITY
// =====================================================================
// Check if user can run SEO (has subscription or trial eligible)
export const checkSeoEligibilityApi = (data) =>
  postRequest("seo/check-eligibility/", data);

// Initiate trial payment
export const initiateSeoTrialPaymentApi = (data) =>
  postRequest("seo/trial/initiate-payment/", data);

// Verify trial payment
export const verifySeoTrialPaymentApi = (data) =>
  postRequest("seo/trial/verify-payment/", data);

export const confirmNewPasswordApi = (data) =>
  postRequest("password-reset/confirm/", data);

// =====================================================================
// BILLING & CREDITS
// =====================================================================
export const deductCreditsApi = (data) =>
  postRequest("deduct-credits/", data);

export const toggleAutoRenewApi = (data) =>
  postRequest("toggle-auto-renew/", data);

export const updateBillingCycleApi = (data) =>
  postRequest("update-billing-cycle/", data);

